import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router';
import { service } from '@ember/service';
import type SessionContextService from 'tio-employee/services/session-context';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type PartnerService from 'tio-employee/services/partner';
import type FeaturesService from 'tio-common/services/features';
import type WellnessTrainRecalculatorService from 'tio-common/services/wellness-train-recalculator';

export default class AuthenticatedWellnessInsightsIndexRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare sessionContext: SessionContextService;
  @service declare partner: PartnerService;
  @service declare features: FeaturesService;
  @service declare wellnessTrainRecalculator: WellnessTrainRecalculatorService;

  queryParams = {
    accountCreationFeedbackActive: { refreshModel: false, replace: true },
  };

  beforeModel() {
    // Redirect if feature is disabled or if TA-only context
    if (!this.features.isEnabled('wellnessInsights') || this.partner.isTaOnly) {
      this.router.transitionTo('authenticated.dashboard');
    }
  }

  async model() {
    const currentUser = this.sessionContext.user;

    // Trigger wellness train recalculation before fetching data
    await this.wellnessTrainRecalculator.recalculate.perform();

    // fetch these separately because wellness trains aren't a real resource
    const answerProfileReq = this.store.query('answer-profile', {
      filter: { user: currentUser.id },
      include: 'user',
    });
    const wellnessTrainReq = this.store.queryRecord('wellness-train', { userId: currentUser.id });

    const [_, wellnessTrain] = await Promise.all([answerProfileReq, wellnessTrainReq]);

    // ensure current user has an answer profile
    if (!currentUser.answerProfile) {
      this.store.createRecord('answer-profile', {
        user: currentUser,
        providingApp: 'tio-employee',
      });
    }

    // get wellness insights data
    return wellnessTrain;
  }
}
